import { type LegalFormCategory } from "./types";

const KAPITAL = new Set(["GmbH", "Unternehmergesellschaft (haftungsbeschränkt)", "AG", "SE", "KGaA"]);
// transparent forms that are still a Gewerbebetrieb + publication-obligated (haftungsbeschränkt)
const KAPCO = new Set(["GmbH & Co. KG", "B.V. & Co. KG"]);
// transparent Gewerbe without publication obligation
const GEWERBE_TRANSPARENT = new Set(["Einzelunternehmen", "GbR", "OHG", "KG"]);
// freie Berufe: no Gewerbesteuer, no Offenlegung
const FREIE_BERUFE = new Set(["Freiberufler", "Partnerschaftsgesellschaft"]);

export const getLegalFormCategory = (legalForm: string | null | undefined): LegalFormCategory => {
    const form = (legalForm ?? "").trim();
    if (KAPITAL.has(form)) {
        return { isKapitalgesellschaft: true, isGewerbe: true, offenlegungspflichtig: true, known: true };
    }
    if (KAPCO.has(form)) {
        return { isKapitalgesellschaft: false, isGewerbe: true, offenlegungspflichtig: true, known: true };
    }
    if (GEWERBE_TRANSPARENT.has(form)) {
        return { isKapitalgesellschaft: false, isGewerbe: true, offenlegungspflichtig: false, known: true };
    }
    if (FREIE_BERUFE.has(form)) {
        return { isKapitalgesellschaft: false, isGewerbe: false, offenlegungspflichtig: false, known: true };
    }
    // Verein/Genossenschaft/Sonstige/empty → conservative: emit no VZ/Offenlegung rows
    return { isKapitalgesellschaft: false, isGewerbe: false, offenlegungspflichtig: false, known: false };
};
